import { ColumnFiltersState, Table } from '@tanstack/react-table';
import { snakeCase } from 'lodash';
import React from 'react';
import { LuDownload } from 'react-icons/lu';

import { MetaData, ResourceType } from '@/cip/_openapi/portfolio-optimizer';
import { useDataExport } from '@/cip/api/dataExport';

import { Button } from '../ui/button';

interface ExportResultsProps<T> {
    table: Table<T>;
    resourceType: ResourceType;
    metaData?: MetaData;
    additionalFilters?: ColumnFiltersState;
    label?: string;
    variant?: 'outline' | 'default';
}

export function ExportResults<T>({
    table,
    resourceType,
    metaData,
    additionalFilters = [],
    label = 'Export Results',
    variant = 'outline',
}: ExportResultsProps<T>) {
    const { mutate, isPending } = useDataExport(resourceType, metaData);

    const handleExport = () => {
        const columns = table
            .getAllLeafColumns()
            .filter((column) => !column.columnDef.meta?.isDisplayCol && column.getIsVisible())
            .map((col) => col.id && snakeCase(col.id))
            .filter(Boolean);

        const { sorting, columnFilters } = table.getState();
        const allFilters = [...additionalFilters, ...columnFilters];
        mutate({ columns, sorting, columnFilters: allFilters });
    };

    return (
        <Button variant={variant} size="sm" className="gap-2" onClick={handleExport} disabled={isPending}>
            <LuDownload className="h-4 w-4" />
            {isPending ? 'Exporting...' : label}
        </Button>
    );
}
